module.exports = __webpack_public_path__ + "img/noScreenshotAvailable.25f98f5d.png";